/* eslint-disable react/prop-types */
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import * as React from 'react';
import { useNavigate } from "react-router-dom";
import { useState } from 'react';
import Loading from 'components/Loading';
import { toast } from 'react-toastify';
import fixTableCellWidth from 'utils/fixTableCellWidth';
import SoftBadge from 'components/SoftBadge';
import { deleteMissionCategory } from 'services/mission.routes';


function Row(props) {
    const { row, navigate, handleDeleteCategory } = props;

    return (
        <React.Fragment>
            <TableRow
                sx={{ '& > *': { borderBottom: 'unset' }, backgroundColor: row.id % 2 === 1 ? "" : "rgba(204,204,204,0.1)" }}>
                <TableCell className="tablecell" align="left" title={row.name}
                    style={fixTableCellWidth("160px")}>{row.name}</TableCell>
                <TableCell className="tablecell" align="left" title={row?.access_level_name}
                    style={fixTableCellWidth("160px")}>{row?.access_level_name}</TableCell>
                <TableCell className="tablecell" align="left"
                    style={fixTableCellWidth("140px")}>{row?.level}</TableCell>
                <TableCell className="tablecell" align="left"
                    style={fixTableCellWidth("100px")}><section style={{ display: "flex", cursor: 'pointer' }}>
                        <SoftBadge variant="contained"
                            onClick={() => navigate(`/new-mission-category?method=update`, { state: row })}
                            badgeContent="آپدیت"
                            color="secondary" size="xs" />
                        <SoftBadge variant="contained"
                            badgeContent="حذف" onClick={() => handleDeleteCategory(row.id)}
                            color="error" size="xs" />
                    </section></TableCell>
            </TableRow>
        </React.Fragment>
    );
}

export default function MissionCategoryTable({ data }) {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false);

    const handleDeleteCategory = (categoryId) => {
        let answer = window.confirm("آیا از حذف اطمینان دارید؟");
        if (answer) {
            setLoading(true);
            deleteMissionCategory(categoryId, (isOk, data) => {
                if (!isOk) {
                    setLoading(false);
                    return toast.error(data.message)
                } else {
                    setLoading(false);
                    toast.success("دسته بندی ماموریت حذف شد!");
                }
            })
        }
    }
    return (
        <>
            <Loading loading={loading} />
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <SoftBadge onClick={() => navigate("/new-mission-category")} variant="contained"
                            badgeContent="دسته بندی جدید" color="success" size="xs"
                            container
                            style={{ cursor: 'pointer' }} />
                        <TableRow>
                            <TableCell className="tablecell" style={fixTableCellWidth("150px")}>نام</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("150px")}>دسترسی</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("150px")}>سطح</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("150px")}>عملیات</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody style={{ display: 'block' }}>
                        {data.map((row) => (
                            <Row key={row.id} row={row} navigate={navigate} handleDeleteCategory={handleDeleteCategory} />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
}
